function getEnvelope(eventTypeId: string) {
  return {
    event_template_id: '71',
    event_template_version_id: '1',
    event_type_id: eventTypeId,
    event_type_version_id: '1',
    event_client_start_dtm: new Date().toISOString(),
  };
}

function getTrigger({
  triggerSourceName,
  triggerObjectName = 'rental_application_object',
  triggerLocationName = 'rental_application',
  triggerType = 'interaction',
}: {
  triggerSourceName: string;
  triggerObjectName?: string;
  triggerLocationName?: string;
  triggerType?: 'impression' | 'interaction';
}) {
  return {
    trigger_location_nm: triggerLocationName,
    trigger_type_nm: triggerType,
    trigger_object_nm: triggerObjectName,
    trigger_source_nm: triggerSourceName,
  };
}

function getSemantic(semanticEventName: string) {
  return {
    semantic_event_nm: semanticEventName,
    topic_tag_txt: ['rental_application'],
  };
}

// https://dataportal.zillowgroup.net/event-registry/2041
export const CLICKSTREAM_PRINT_CREDIT_REPORT = {
  envelope: getEnvelope('2041'),
  clickstream_trigger: getTrigger({
    triggerLocationName: 'rental_application',
    triggerSourceName: 'confirm_print_credit_report',
    triggerObjectName: 'rental_application_object_screening_section',
  }),
  semantic: getSemantic('print_credit_report'),
};

// https://dataportal.zillowgroup.net/event-registry/2042
export const CLICKSTREAM_PRINT_BACKGROUND_REPORT = {
  envelope: getEnvelope('2042'),
  clickstream_trigger: getTrigger({
    triggerLocationName: 'rental_application',
    triggerSourceName: 'confirm_print_background_report',
    triggerObjectName: 'rental_application_object_screening_section',
  }),
  semantic: getSemantic('print_background_report'),
};
